<template>
  <div v-if="!apiCallInProgress" class="c-results-wrapper">
    <SearchResultsCats v-if="showCats" :term="term" :contentTypes="contentTypes" :results="results" :units="units" :showAllTab="showAllTab"/>
    <SearchResultsCont v-else :term="term" :results="results" :units="units"/>
  </div>
  <ContentLoader v-else>
    <rect x="0" y="0" width="35%" height=".5rem" />
    <rect x="0" y=".75rem" width="45%" height=".325rem" />
    <rect x="0" y="1.25rem" width="45%" height=".325rem" />
    <rect x="0" y="1.75rem" width="40%" height=".325rem" />
  </ContentLoader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import mappedData from './mapResults.js'
import SearchResultsCats from './SearchResultsCats'
import SearchResultsCont from './SearchResultsCont'

export default {
  name: "SearchResults",

  components: {
    ContentLoader,
    SearchResultsCats,
    SearchResultsCont
  },

  created() {
    this.initAbortController()
    this.emitIsSearchingStatus()
  },

  data () {
    return {
      results: [],
      mappedData: mappedData,
      apiCallInProgress: false
    }
  },

  methods: {
    emitIsSearchingStatus() {
      this.$emit('searching-in-progress', this.apiCallInProgress)
    },
    initAbortController() {
      this.controller = new AbortController()
      this.signal = this.controller.signal
    },
    async onSubmittedTerm (term) {
      if (this.apiCallInProgress) {
        this.controller.abort()
        this.initAbortController()
      }
      this.apiCallInProgress = true
      this.emitIsSearchingStatus()
      var params = new URLSearchParams({
        index: this.indexName,
        body: this.searchQuery
      })
      let response
      try {
        response = await (await (fetch(`${this.searchBaseURL}/v1/search?${params}`, {signal: this.signal}))).json()
      }
      catch(err) {
        this.apiCallInProgress = false
        this.$emit('on-result-count', 0)
        this.emitIsSearchingStatus()
        if (err.name == 'AbortError') {
          return
        } else {
          throw err
        }
      }
      this.apiCallInProgress = false
      if (term == this.term) {
        this.results = []
        let groupedResults = this.groupByType(response.hits.hits)
        this.contentTypes.forEach(type => {
          if (Object.keys(groupedResults).some(v => v == type)) {
            this.results.push(...groupedResults[type])
          }
        })
        this.$emit('on-result-count', this.results.length)
        this.results = this.results.slice(0, this.limit)
      }
      this.emitIsSearchingStatus()
    },
    groupByType(results) {
      return results.reduce((result, currentValue) => {
        (result[currentValue._source.content_type] = result[currentValue._source.content_type] || []).push(
          currentValue
        );
        return result;
      }, {});
    }
  },

  async mounted () {
    await this.onSubmittedTerm(this.term)
  },

  props: {
    term: String,
    showCats: Boolean,
    contentTypes: Array,
    searchBaseURL: String,
    searchQuery: String,
    indexName: String,
    units: Array,
    limit: {
      type: Number,
      default: 100
    },
    showAllTab: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    'term': async function(val) {
      await this.onSubmittedTerm(val)
    }
  }
}
</script>
